import { render, staticRenderFns } from "./ModalResult.vue?vue&type=template&id=0508f570&"
import script from "./ModalResult.vue?vue&type=script&lang=js&"
export * from "./ModalResult.vue?vue&type=script&lang=js&"
import style0 from "./ModalResult.vue?vue&type=style&index=0&id=0508f570&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports